var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goal-list-layout pt-10 "},[_c('DatepickerWithArrow',{model:{value:(_vm._selectedDate),callback:function ($$v) {_vm._selectedDate=$$v},expression:"_selectedDate"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }